import { BehaviorParameters } from 'rangeConfig/@types';

const replaceProductIgnoreStability = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return;
  }
  const newProductType =
    rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId)?.type || '';
  const oldProductType = coreApi.entities.getProductType(selectedEntity) || '';

  if (newProductType === oldProductType) {
    const replacePlacementResult = coreApi.products.replace(selectedEntity.id, props.coreProductId);
    const errors = replacePlacementResult?.replacedEntityResult.errors || [];
    const errorsExcludingStabilityErrors = errors.filter(
      e => e.failedRule?.id !== 'STABILITY_ZONE_VALIDATION'
    );
    if (
      errorsExcludingStabilityErrors.length === 0 &&
      replacePlacementResult?.replacedEntityResult.placedEntity
    ) {
      coreApi.entities.select(replacePlacementResult.replacedEntityResult.placedEntity);
    } else {
      coreApi.history.undo();
      coreApi.history.discardLatestSnapshot();
    }
  } else {
    const replacePlacementResult = coreApi.products.removeAndAdd(
      selectedEntity.id,
      props.coreProductId
    );
    if (replacePlacementResult?.valid && replacePlacementResult.placedEntity) {
      coreApi.entities.select(replacePlacementResult.placedEntity);
    }
  }
};

export default replaceProductIgnoreStability;
